import { render, staticRenderFns } from "./CreateOptionPreset.vue?vue&type=template&id=6ec89750&scoped=true"
import script from "./CreateOptionPreset.vue?vue&type=script&lang=js"
export * from "./CreateOptionPreset.vue?vue&type=script&lang=js"
import style0 from "./CreateOptionPreset.vue?vue&type=style&index=0&id=6ec89750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec89750",
  null
  
)

export default component.exports